import React, { useState } from 'react'
import { FormHelperText } from '@mui/material'
import {
  TextParagraph,
  Heading,
  FormRowHolder,
  FormHeaderHolder,
  FormFieldHolder,
} from '../../../../styles'
import CustomDatePicker from '../../../ui/datePicker'
import { useFormContext } from '../../../../contexts/Form'
import { GENERATE_FEED_FIELDS } from '../../../../constants'

const ArchiveFeedSettings = () => {
  const { formState: formContextState, callbacks: formContextCallbacks } = useFormContext()
  const { setFormData, setFormValidity } = formContextCallbacks
  const { data: formData, errors } = formContextState
  const [minBillEndDate, setMinBillEndDate] = useState(null)

  const onArchiveStartDateChange = (momentObj) => {
    const date = momentObj.toDate()
    const nextDate = momentObj.add(1, 'days').toDate()
    setMinBillEndDate(nextDate)
    setFormData(GENERATE_FEED_FIELDS?.archiveStart?.key, date)
  }

  const onArchiveEndDateChange = (momentObj) => {
    delete errors['archive_end_date']
    setFormValidity(formContextState.isFormValid, errors)
    const date = momentObj.toDate()
    setFormData(GENERATE_FEED_FIELDS?.archiveEnd?.key, date)
  }

  return (
    <div>
      <Heading top>Archive feed settings</Heading>
      <FormRowHolder>
        <FormHeaderHolder>
          <TextParagraph size={'14px'}>Article Range:</TextParagraph>
        </FormHeaderHolder>
        <FormFieldHolder extraPadding='9px'>
          <CustomDatePicker
            label='From'
            format='MM/DD/YYYY'
            value={formData?.[GENERATE_FEED_FIELDS?.archiveStart?.key] || null}
            onChangeHandler={onArchiveStartDateChange}
            disabled={false}
          />
          <div style={{ margin: '0px 20px' }}> to </div>
          <div>
            <CustomDatePicker
              label='To'
              format='MM/DD/YYYY'
              value={formData?.[GENERATE_FEED_FIELDS?.archiveEnd?.key] || null}
              onChangeHandler={onArchiveEndDateChange}
              disabled={!formData.archive_start_date}
              minDate={minBillEndDate}
            />
            {!errors.isValid && errors?.archive_end_date && (
              <FormHelperText
                id={'outlined-archive_end_date-helper-text'}
                error
                data-testid={'archive_end_date-errmessage'}
              >
                {errors.archive_end_date}
              </FormHelperText>
            )}
          </div>
        </FormFieldHolder>
      </FormRowHolder>
    </div>
  )
}

export default ArchiveFeedSettings
